export const VWO_COOKIE_VALUES = {
  ACCEPTED: 1,
  PENDING: 2,
  DENIED: 3,
} as Record<string, number>;

export type VWOCookieValues = (typeof VWO_COOKIE_VALUES)[number];
